import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { untilDestroyed } from '$core/operators/until-destroyed.operator';
import { debounceTime } from 'rxjs/operators';
import { BatchShort } from '../../../batches';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiltersComponent implements OnInit, OnDestroy {
  @Output() public removeChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() public searchChange: EventEmitter<string | null> = new EventEmitter<
    string | null
  >();
  @Input() public selected: BatchShort[];

  public readonly faTrashAlt = faTrashAlt;
  public searchControl: FormControl = this._fb.control(
    this.queryParamMap.get('search')
  );
  constructor(
    private readonly _fb: FormBuilder,
    private _route: ActivatedRoute
  ) {}

  public get queryParamMap() {
    return this._route.snapshot.queryParamMap;
  }

  public ngOnDestroy(): void {}

  public ngOnInit(): void {
    this.listenToSearch();
  }

  public listenToSearch(): void {
    this.searchControl.valueChanges
      .pipe(debounceTime(350), untilDestroyed(this))
      .subscribe((res) => {
        this.searchChange.next(res || null);
      });
  }

  public remove(): void {
    this.removeChange.next(true);
  }
}
